import styled from 'styled-components'
import { Spacings, Text } from '@styles'

// caption — Desktop/Body/Regular/caption: Inter 0.75rem / 400 / 1rem line-height (Gray/500)
const captionStyles = `
	font-size: ${Text.SMALL};
	font-weight: ${Text.BOLD_400};
	line-height: ${Spacings.SPACING_4B};
`

const ItemCardField = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};
`

// Field wrapper for form controls — value text = Desktop/Body/Regular/M (Inter 0.875rem / 400)
export const ItemCardControlField = styled(ItemCardField)`
	& input,
	& select {
		font-weight: ${Text.BOLD_400};
	}
`

export const ItemCardFieldLabel = styled.span`
	${captionStyles};
	color: ${({ theme }) => theme.colors.text.secondary};
`

export const ItemCardFieldValue = styled.span`
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.colors.text.primary};
	overflow-wrap: break-word;
	word-break: break-word;
`

export const ItemCardProductMeta = styled.span`
	font-size: ${Text.EXTRA_SMALL};
	color: ${({ theme }) => theme.colors.text.greyFour};
	overflow-wrap: break-word;
	word-break: break-word;
`

// compact always-visible trigger shown under the Rate input — reveals the per-supplier
// IFC price hint in a floating Tooltip on hover/tap
export const IfcTrigger = styled.span`
	${captionStyles};
	display: inline-flex;
	align-items: center;
	gap: ${Spacings.SPACING_1B};
	padding: ${Spacings.SPACING_1B} 0;
	color: ${({ theme }) => theme.colors.brand.primary};
	font-weight: ${Text.BOLD_700};
	cursor: pointer;
	width: fit-content;
`

// stacked per-supplier IFC price lines — rendered only inside the Tooltip's `content`, not in the page layout
export const IfcTooltipList = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_1B};

	& > div {
		${captionStyles};
	}

	& b {
		color: ${({ theme }) => theme.colors.text.primary};
	}
`
